function initAutocomplete() {
	jQuery(document).ready(function($)
	{
		$('input.autocomplete').each(function(){
			var input=this;
			var field=$(input).closest('form').find('input[name="'+$(input).data('field')+'"]');
			if(field.val()!="")
			{
				try
				{
					var data=JSON.parse($.base64.decode(field.val()));
					if(typeof data.value != "undefined")
						$(input).val(data.value);
				}
				catch(e)
				{
					
				}
			}
			autocomplete = new google.maps.places.Autocomplete(this);
			autocomplete.addListener('place_changed', function(){			
				var place = autocomplete.getPlace();

				var data={};
				data.value=$(input).val();
				data.place_id=place.place_id;
				for (var i = 0; i < place.address_components.length; i++) {
					if(place.address_components[i].types[0]=="locality")//city
						data.city=place.address_components[i]["long_name"];
						
					if(place.address_components[i].types[0]=="administrative_area_level_1")//state
						data.state=place.address_components[i]["short_name"];

					if(place.address_components[i].types[0]=="postal_code")
						data.zip=place.address_components[i]["short_name"];
					
				}
				field.val($.base64.encode(JSON.stringify(data))).trigger('change');

			});

			$(input).change(function(){
				if($(this).val()=="")
					field.val('');
			});
		});		
		
	});
}